import { createAction } from 'typesafe-actions';
import { EnqueueToast, RemoveToast } from './types';

export const TOAST_ENQUEUE = 'ENQUEUE_TOAST';
export const TOAST_REMOVE = 'REMOVE_TOAST';

export const enqueueToast = createAction(TOAST_ENQUEUE)<EnqueueToast>();
export const removeToast = createAction(TOAST_REMOVE)<RemoveToast>();
